import * as ACWActions from './acw.reducer'

export const { setACWDuration } = ACWActions
